import { dataMigrate } from 'dls-icons-data'
import { createIcon } from '../common'

const IconMigrate = /*#__PURE__*/createIcon(dataMigrate)
export default IconMigrate
